import SliderListesi from "./Modules/Slider/SliderListesi";
import SliderDetay from "./Modules/Slider/SliderDetay";

export default {
  namespaced: true,
  modules: {
    SliderListesi,
    SliderDetay,
  },
};
